import { jsx } from 'react/jsx-runtime';
import { NOOP } from '@lemonade-hq/ts-helpers';
import React from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var ACCORDION_DEFAULT_ID = "default-accordion-id";
var getAccordionId = function(id) {
    return id != null ? id : ACCORDION_DEFAULT_ID;
};
var AccordionContext = /*#__PURE__*/ React.createContext(null);
var Provider = function(param) {
    var children = param.children, id = param.id, isOpen = param.isOpen, toggle = param.toggle, disabled = param.disabled, enforcedProps = param.enforcedProps;
    var memoizedValue = React.useMemo(function() {
        return {
            id: id,
            isOpen: isOpen,
            toggle: toggle,
            disabled: disabled,
            enforcedProps: enforcedProps
        };
    }, [
        id,
        isOpen,
        toggle,
        disabled,
        enforcedProps
    ]);
    return /*#__PURE__*/ jsx(AccordionContext.Provider, {
        value: memoizedValue,
        children: children
    });
};
var useAccordion = function() {
    var getSummaryProps = function getSummaryProps(props) {
        var accordionId = getAccordionId(accordionContext === null || accordionContext === void 0 ? void 0 : accordionContext.id);
        var defaultProps = {
            "aria-controls": "".concat(accordionId, "-content"),
            id: "".concat(accordionId, "-header")
        };
        if (props == null) {
            return defaultProps;
        }
        return _object_spread({}, defaultProps, props);
    };
    var getDetailsProps = function getDetailsProps(props) {
        var accordionId = getAccordionId(accordionContext === null || accordionContext === void 0 ? void 0 : accordionContext.id);
        var _accordionContext_isOpen;
        var defaultProps = {
            "aria-labelledby": "".concat(accordionId, "-header"),
            id: "".concat(accordionId, "-content"),
            "aria-expanded": (_accordionContext_isOpen = accordionContext === null || accordionContext === void 0 ? void 0 : accordionContext.isOpen) !== null && _accordionContext_isOpen !== void 0 ? _accordionContext_isOpen : false,
            role: "region"
        };
        if (props == null) {
            return defaultProps;
        }
        return _object_spread({}, defaultProps, props);
    };
    var getAccordionProps = function getAccordionProps(props) {
        var _accordionContext_disabled;
        var defaultProps = {
            "aria-disabled": (_accordionContext_disabled = accordionContext === null || accordionContext === void 0 ? void 0 : accordionContext.disabled) !== null && _accordionContext_disabled !== void 0 ? _accordionContext_disabled : false
        };
        if (props == null) {
            return defaultProps;
        }
        return _object_spread({}, defaultProps, props);
    };
    var accordionContext = React.useContext(AccordionContext);
    if (accordionContext == null) {
        // eslint-disable-next-line no-console
        console.error("useAccordion must be used in a component under a <AccordionProvider /> or context instances are mismatched. Are you updated to the latest CDK version?");
        accordionContext = {
            isOpen: true,
            toggle: NOOP,
            id: ACCORDION_DEFAULT_ID,
            disabled: false
        };
    }
    return _object_spread({
        getSummaryProps: getSummaryProps,
        getDetailsProps: getDetailsProps,
        getAccordionProps: getAccordionProps
    }, accordionContext);
};

export { ACCORDION_DEFAULT_ID, AccordionContext, Provider, useAccordion };
